module.exports = __webpack_public_path__ + "static/media/banner-credCarb.7a273e41.png";